import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import vSelect from 'vue-select';

export default Vue.component('edit-profile-feed', {
  template: require('./template.html'),
  name: 'edit-profile-feed',
  props: ['droplet', 'show-edit-bubble'],
  components: {
    vSelect,
  },
  computed: {
    ...mapGetters(['currentSite']),
    dynamicEnabled() {
      return this.currentSite.dynamic && this.currentSite.dynamic.profiles;
    },
    categoryOptions() {
      let list = [];
      if (this.dynamicEnabled) {
        list = this.dynamicEnabled.categories;
      }
      return list;
    },
  },
  data() {
    return {
      display: {
        filters: null,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.display.filters = _.clone(this.droplet.filters);
    },
    selectCategory(list) {
      if (list) {
        const val = _.clone(list);
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: 'filters',
          val,
        });
      }
    },
    radioUpdate(val, key) {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key,
        val,
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/profile-feed/components/_edit-options/index.js